// src/features/dashboard/hooks/useDashboard.js
import { useState, useEffect } from 'react';
import dashboardApi  from '../services/dashboardApi';

export const useDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  let mounted = true;

  const fetchDashboardData = async () => {
    try {
      setLoading(true);

      const response = await dashboardApi.getOHCDashboard();

      if (!mounted) return;

      if (response.success) {
        setDashboardData(response.data);
      } else {
        setError('Failed to load dashboard data');
      }

    } catch (err) {
      if (mounted) setError(err.message);
    } finally {
      if (mounted) setLoading(false);
    }
  };

  fetchDashboardData();

  return () => {
    mounted = false;
  };

}, []);

  return { dashboardData, loading, error };
};